export enum SpareWheelType {
	NO = "NO",
	YES = "YES",
}
